import { useSelector } from "react-redux";
import Slider from "react-slick";
import SectionLoader from "../sectionloader";

const Banner = () => {
  const { banners, loading } = useSelector((item) => item.interface);
  const settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 1800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
  };
  if (loading) {
    return <SectionLoader aspectRatio="640/187" />;
  }

  return (
    <section className="banner-section top-banner" style={{ width: "100%" }}>
      <Slider {...settings}>
        {banners.map((banner) => (
          <div className="outline-none">
            <img src={banner.url} alt="Slide 1" style={{ width: "100%" }} />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Banner;
